import {
  Image,
  Box,
  Flex,
  Heading,
  Stack,
  Text,
  Select,
  SimpleGrid,
  Tabs,
  TabPanel,
  TabPanels,
  TabList,
  Tab,
} from "@chakra-ui/react";
import React from "react";
import CommonContainer from "../../components/shared/CommonContainer";
import { Link } from "react-router-dom";

export default function FreelancerGigsPage() {
  const [tab, setTab] = React.useState("Active");
  return (
    <CommonContainer>
      <Stack my={{ base: 10, lg: 20 }}>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "21px", md: "26px" }}
          pb={10}
        >
          Gigs
        </Heading>
        <Flex
          justifyContent="space-between"
          alignItems="start"
          mb={10}
          display={{ base: "none", xl: "flex" }}
        >
          <Box
            fontSize={{ base: "14px", lg: "16px" }}
            w={{ xl: "250px" }}
            pr={1}
            fontWeight="medium"
          >
            {linksData.map((item, index) => {
              return (
                <Text
                  mb={3}
                  key={index}
                  color={tab === item.label ? "brand.500" : "#c5c5c5"}
                  cursor="pointer"
                  onClick={() => {
                    setTab(item.label);
                  }}
                >
                  {item.label}{" "}
                  {item.label === "Active" && tab === "Active" && (
                    <Box
                      as="span"
                      color="white"
                      bg="brand.500"
                      px="8px"
                      py="4px"
                      ml={1}
                      align="center"
                      display="inline"
                      fontSize="16px"
                      rounded={"full"}
                    >
                      2
                    </Box>
                  )}
                </Text>
              );
            })}
          </Box>
          <Box
            px={{ base: 5, md: 10, xl: 20 }}
            fontSize={{ md: "19px" }}
            w={{ xl: "90%" }}
            borderLeft="1px"
            borderColor="#707070"
          >
            <GridBox tab={tab} />
          </Box>
        </Flex>
        {/* Mobile version */}
        <Tabs variant="" isFitted display={{ base: "block", xl: "none" }}>
          <TabList overflow="auto">
            {linksData.map((item) => {
              return (
                <Tab
                  _selected={{ color: "white", bg: "brand.500" }}
                  bg="#f4f4f4"
                  onClick={() => {
                    setTab(item.label);
                  }}
                  key={item.label}
                >
                  {item.label}
                  {item.label === "Active" && tab === "Active" && (
                    <Text
                      bg="white"
                      color="brand.500"
                      px="8px"
                      // py="4px"
                      ml={1}
                      align="center"
                      display="inline"
                      fontSize="16px"
                      rounded={"full"}
                      height="25px"
                    >
                      2
                    </Text>
                  )}
                </Tab>
              );
            })}
          </TabList>
          <TabPanels>
            {linksData.map((item) => {
              return (
                <TabPanel px={0} key={item.label}>
                  <Box overflow="hidden">
                    <GridBox tab={tab} />
                  </Box>
                </TabPanel>
              );
            })}
          </TabPanels>
        </Tabs>
      </Stack>
    </CommonContainer>
  );
}
const GridBox = ({ tab }) => {
  return (
    <>
      <Flex
        justifyContent="space-between"
        fontWeight="medium"
        px={5}
        py={2}
        alignItems="center"
      >
        <Text fontSize={{ base: "18px", lg: "26px" }} fontWeight="semibold">
          {tab} Gigs
        </Text>
        <Select placeholder="Today" w="max-content">
          <option>Last 7 Days</option>
          <option>Last 14 Days</option>
          <option>Last 20 Days</option>
        </Select>
      </Flex>
      <SimpleGrid
        // w={{ xl: "90%" }}
        columns={{ base: 1, lg: 2, "2xl": 3 }}
        my={10}
        gap={8}
        px={5}
      >
        <Box border="1px solid #c5c5c5" borderRadius={10} overflow={"hidden"}>
          <Image src="/images/freelancer/gig.png" />
          <Text
            p={4}
            borderTop="1px"
            color="rgba(0,0,0,0.42)"
            sx={{ marginTop: "0px" }}
          >
            Design retro vintage logo design
          </Text>
          <Flex gap={0} m={0} flexWrap={"wrap"}>
            <Stack
              fontSize={{ base: "16px", lg: "20px" }}
              color="rgba(0,0,0,0.42)"
              alignItems="center"
              justifyContent={"center"}
              p={1}
              borderRight="1px"
              borderTop="1px"
              borderColor="#c5c5c5"
              flex={2}
            >
              <Text>Impressions</Text>
              <Text>0</Text>
            </Stack>
            <Stack
              fontSize={{ base: "16px", lg: "20px" }}
              color="rgba(0,0,0,0.42)"
              alignItems="center"
              justifyContent={"space-evenly"}
              borderRight="1px"
              borderTop="1px"
              borderColor="#c5c5c5"
              p={1}
              flex={1}
            >
              <Text>Clicks</Text>
              <Text>0</Text>
            </Stack>
            <Stack
              fontSize={{ base: "16px", lg: "20px" }}
              color="rgba(0,0,0,0.42)"
              alignItems="center"
              justifyContent={"space-evenly"}
              borderRight="1px"
              borderTop="1px"
              borderColor="#c5c5c5"
              p={1}
              flex={1}
            >
              <Text>Orders</Text>
              <Text>0</Text>
            </Stack>
            <Stack
              fontSize={{ base: "16px", lg: "20px" }}
              color="rgba(0,0,0,0.42)"
              alignItems="center"
              justifyContent={"space-evenly"}
              borderTop="1px"
              borderColor="#c5c5c5"
              p={1}
              flex={2}
            >
              <Text>Cancellations</Text>
              <Text>0</Text>
            </Stack>
          </Flex>
        </Box>

        <Stack
          gap={2}
          justifyContent="center"
          alignItems="center"
          bg="#f4f4f4"
          border="1px solid #c5c5c5"
          borderRadius={10}
          h="full"
          minHeight="200px"
          w="full"
        >
          <Image src="/images/freelancer/dashboard/create-gig.png" />
          <Link to="/freelancer/gig/create">
            <Text
              color="brand.500"
              fontSize="20px"
              fontWeight="semibold"
              cursor="pointer"
            >
              Create A Gig
            </Text>
          </Link>
        </Stack>
      </SimpleGrid>
    </>
  );
};
const linksData = [
  {
    label: "Active",
    path: "",
  },
  {
    label: "Pending Approval",
    path: "",
  },
  {
    label: "Requires Modification",
    path: "",
  },
  {
    label: "Draft",
    path: "",
  },
  {
    label: "Denied",
    path: "",
  },
];
